<template>
    <base-layout>
        <template v-slot:header>
            <app-header />
        </template>
        <template v-slot:banner>
            <section class="banner_area">
                <div class="banner_inner d-flex align-items-center">
                    <div class="container">
                        <div class="banner_content d-md-flex justify-content-between align-items-center">
                            <div class="mb-3 mb-md-0">
                                <h2>Shop</h2>
                            </div>
                            <div class="page_link">
                                <a href="/">Home</a>
                                <a :href="`/Shop`">Shop</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
        <template v-slot:default>
            <section class="cat_product_area">
                <div class="container">
                    <div class="row flex-row-reverse">
                        <Product v-for="item in products" :key="item.id" :product="item"/>
                    </div>
                </div>
            </section>
        </template>

        <template v-slot:footer>
            <app-footer />
        </template>
    </base-layout>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Product from '@/components/Product'
import products from '../config/products.json'
import BaseLayout from '@/layout/BaseLayout'

export default {
  // title(){
  //     return
  // },
  title: 'Shop - SanitizerWristbands.com',
  components: {
    BaseLayout,
    AppHeader,
    Product,
    AppFooter
  },
  data () {
    return {
      products
    }
  }
}
</script>
<style>
.clickable {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/Shop.vue